/* eslint-disable camelcase */
import sha512 from 'crypto-js/sha512'
import { fetchList, login, logout, listCoach, listStudent } from '@/api/user'
import { resetRouter } from '@/router'
import { getToken, getUserData, removeUserData, setUserData } from '@/utils/auth'

const state = {
  token: getToken(),
  userDate: getUserData(),
  list: [],
  coachList: [],
  studentList: [],
}

const mutations = {
  SET_TOKEN: (state, token) => {
    state.token = token
  },
  SET_USERDATA: (state, userData) => {
    state.userData = userData
  },
  SET_LIST: (state, list) => {
    state.list = list
  },
  SET_COACHLIST: (state, coachList) => {
    state.coachList = coachList
  },
  SET_STUDENTLIST: (state, studentList) => {
    state.studentList = studentList
  },
}

const actions = {
  listCoach({ commit }) {
    return new Promise((resolve, reject) => listCoach({
      page: 0,
      limit: 0,
    })
      .then(response => {
        // console.log('store list response', response)
        const { data } = response
        commit('SET_COACHLIST', data.items)
        resolve(data.items)
      })
      .catch(error => {
        console.log('error', error)
        reject(error)
      }))
  },
  listStudent({ commit }) {
    return new Promise((resolve, reject) => listStudent({
      page: 0,
      limit: 0,
    })
      .then(response => {
        // console.log('store list response', response)
        const { data } = response
        commit('SET_STUDENTLIST', data.items)
        resolve(data.items)
      })
      .catch(error => {
        console.log('error', error)
        reject(error)
      }))
  },
  list({ commit }, parameter) {
    console.log('store list parameter', parameter)

    return new Promise((resolve, reject) => fetchList(parameter)
      .then(response => {
        // console.log('store list response', response)
        const { data } = response
        commit('SET_LIST', data.items)
        resolve(data)
      })
      .catch(error => {
        console.log('error', error)
        reject(error)
      }))
  },

  // user logout
  logout({ commit, state }) {
    return new Promise((resolve, reject) => logout(state.token)
      .then(() => {
        commit('SET_USERDATA', '')
        removeUserData()

        // commit('SET_TOKEN', '')
        // removeToken()
        // removeFirebaseToken()
        // removeUserId()
        resetRouter()
        resolve()
      })
      .catch(error => {
        reject(error)
      }))
  },

  // remove token
  resetToken({ commit, state }) {
    console.log('resetToken state', state)

    return new Promise(resolve => {
      commit('SET_USERDATA', '')
      removeUserData()

      // commit('SET_TOKEN', '')
      // removeToken()
      // removeFirebaseToken()
      // removeUserId()
      resolve()
    })
  },
  login({ commit }, data) {
    console.log('login data', data)
    const { username, password } = data

    // console.log('username', username)
    // console.log('password', password)
    return new Promise((resolve, reject) => login({
      username,
      password: sha512(password.trim()).toString(),
      client_name: 'chrome',
      client_os: 'web',
    })
      .then(response => {
        // console.log('response', response)
        const responseData = response.data.record
        commit('SET_USERDATA', responseData)
        setUserData(responseData)

        // data.id = parseInt(data.id)
        // commit('SET_TOKEN', data.token)
        // setToken(data.token)
        resolve(responseData)
      })
      .catch(error => {
        console.log('error', error)
        reject(error)

        // alert('Login failed. Please contact JobTotal Administrator.')
      }))
  },

}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
}
